import { Box, Typography } from '@mui/material'
import { useState } from 'react'

import AdxDropdown from 'components/custom/AdxDropdown'
import AdxMenuItem from 'components/custom/AdxMenuItem'

import { subDays } from 'date-fns'

import AdxDateRangePicker from 'components/custom/AdxDateRangePicker'
import AttendanceLabelRenderer from 'components/custom/AdxLabelRenderer'
import { timeObjectToDateConverter } from 'services/helper/DateTime'
import AdxDrawerComponent from 'components/reusable/drawer/AdxDrawerComponent'
import AdxButton from 'components/custom/AdxButton'

const filterStatusValues = [
  {
    id: 0,
    value: 'all',
    label: 'all',
  },
  {
    id: 1,
    value: 'present',
    label: 'present',
  },
  {
    id: 2,
    value: 'absent',
    label: 'absent',
  },
  {
    id: 3,
    value: 'late',
    label: 'late',
  },
  {
    id: 4,
    value: 'incomplete',
    label: 'incomplete',
  },
  {
    id: 5,
    value: 'leave',
    label: 'leave',
  },
  {
    id: 6,
    value: 'manual_add',
    label: 'manual_add',
  },
  {
    id: 7,
    value: 'no_shift',
    label: 'no_shift',
  },
]

const filterDeptValues = [
  {
    id: 0,
    value: 'all',
    label: 'all',
  },
  {
    id: 1,
    value: 'development',
    icon: 'check_circle',
    color: 'positive.main',
    label: 'development',
  },
  {
    id: 2,
    value: 'products',
    icon: 'cancel',
    color: 'error.main',
    label: 'products',
  },
  {
    id: 3,
    value: 'human_resources',
    icon: 'error',
    color: 'warning.main',
    label: 'human_resources',
  },
  {
    id: 4,
    value: 'management',
    icon: 'remove_circle',
    color: 'warning.main',
    label: 'management',
  },
  {
    id: 5,
    value: 'coolie',
    icon: 'event_note',
    color: 'light-gray-text.main',
    label: 'coolie',
  },
]

const AttendanceFilterDrawer = ({
  drawerState,
  setDrawerState,
  filterValues,
  setFilterValues,
  disableDepartmentSelector,
}) => {
  // for AdxDateRangePicker
  const currentDateObject = new Date()
  const currentYear = currentDateObject.getFullYear()

  // setting up initial temporary values for filter use
  const [selectedDate, setSelectedDate] = useState({
    start: filterValues.startDate,
    end: filterValues.endDate,
  })
  const [tempDept, setTempDept] = useState(filterValues.dept)
  const [tempStatus, setTempStatus] = useState(filterValues.status)
  const today = new Date()
  const oneWeekBefore = subDays(today, 7)

  // restore default related
  const handleRestoreDefault = () => {
    setSelectedDate({ start: oneWeekBefore, end: today })
    setTempDept('all')
    setTempStatus('all')
  }

  // setting filter values
  const handleFilterDept = (event) => {
    setTempDept(event.target.value)
  }
  const handleFilterStatus = (event) => {
    setTempStatus(event.target.value)
  }
  const newFilterValues = {
    startDate: selectedDate.start,
    endDate: selectedDate.end,
    duration: '',
    dept: tempDept,
    status: tempStatus,
  }
  const handleApplyFilter = () => {
    setFilterValues(newFilterValues)
    setDrawerState({ right: false })
  }

  const handleDrawer = (anchor, open) => (event) => {
    setDrawerState({ ...drawerState, [anchor]: open })
  }

  return (
    <AdxDrawerComponent
      state={drawerState}
      anchor="right"
      onClose={handleDrawer}
      headerprops
      title="Filter"
      header
      footerprops={
        <>
          <Box>
            <Typography sx={{ color: 'dark-text.main', fontWeight: 500 }}>
              {timeObjectToDateConverter(selectedDate.start)}
              {selectedDate?.end && ` - ${timeObjectToDateConverter(selectedDate.end)}`}
            </Typography>
            <Typography sx={{ color: 'light-gray-text.main', fontWeight: 400, fontSize: '12px' }}>
              Date selected
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <AdxButton
              variant={'outlined'}
              sx={{ width: '100px' }}
              onClick={() => {
                setDrawerState({ right: false })
              }}
            >
              Cancel
            </AdxButton>
            <AdxButton
              variant={'contained'}
              sx={{ width: '150px' }}
              onClick={handleApplyFilter}
              disabled={newFilterValues.endDate === null}
            >
              Apply
            </AdxButton>
          </Box>
        </>
      }
      sx={{ width: { xs: '95dvw', md: '640px' } }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'start',
              gap: 2,
              pb: 2,
              borderBottom: 1,
              borderColor: 'gray-line.main',
              width: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography>Date</Typography>

              <AdxButton variant={'ghost'} size={'small'} onClick={() => handleRestoreDefault()}>
                Restore default
              </AdxButton>
            </Box>
            <Box sx={{ width: '100%' }}>
              <AdxDateRangePicker
                selectedYear={currentYear}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
              />
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'start',
              gap: 2,
              mb: 2,
            }}
          >
            {/* {!disableDepartmentSelector && (
              <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
                <AdxDropdown label={'Department'} value={tempDept} onChange={handleFilterDept}>
                  {filterDeptValues.map((value, index) => (
                    <AdxMenuItem value={value.value} selectedvalue={tempDept} key={index}>
                      <Box sx={{ display: 'flex', gap: 2 }}>
                        <Typography sx={{ textTransform: 'capitalize' }}>{value.label}</Typography>
                      </Box>
                    </AdxMenuItem>
                  ))}
                </AdxDropdown>
              </Box>
            )} */}
            {/* <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
              <AdxDropdown label={'Filter Status'} value={tempStatus} onChange={handleFilterStatus}>
                {filterStatusValues.map((value, index) => (
                  <AdxMenuItem value={value.value} selectedvalue={tempStatus} key={index}>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                      <AttendanceLabelRenderer status={value.label} withText />
                    </Box>
                  </AdxMenuItem>
                ))}
              </AdxDropdown>
            </Box> */}
          </Box>
        </Box>
      </Box>
    </AdxDrawerComponent>
  )
}

export default AttendanceFilterDrawer
